import React, { Fragment, memo, useCallback } from 'react'
import tw from 'twin.macro'
import { Typography } from '@mui/material'
import { useSelector } from 'react-redux'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { SectionCard } from 'src/components/shared/SectionCard'
import { buildInternalRolePath } from 'src/constants/routes'
import type { InternalAccessRole } from 'src/interfaces/internalAccess'
import { getInternalRolesError } from 'src/selectors/internalAccess'
import { InternalRolesTable } from './InternalRolesTable'
import { InternalRolesToolbar } from './InternalRolesToolbar'

interface Props {
  onRefresh(): void
}

const InternalRolesTabComponent = ({ onRefresh }: Props) => {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const rolesError = useSelector(getInternalRolesError)

  // `?tab=roles` rides along so the editor's Back returns here, not to the Users tab.
  const handleRowClick = useCallback(
    (role: InternalAccessRole) => {
      navigate({ pathname: buildInternalRolePath(role.id), search: searchParams.toString() })
    },
    [navigate, searchParams],
  )

  return (
    <Fragment>
      <InternalRolesToolbar onRefresh={onRefresh} />
      {rolesError ? (
        <SectionCard title="Roles">
          <Typography variant="body2" css={tw`text-critical-500`}>
            {rolesError}
          </Typography>
        </SectionCard>
      ) : null}
      <InternalRolesTable onRowClick={handleRowClick} />
    </Fragment>
  )
}

export const InternalRolesTab = memo(InternalRolesTabComponent)
